import { RecurrencyPattern } from './recurrency-pattern';
import { OrderTemplate } from './order-template';
import { LoadingTemplate } from './loading-template';

export class TourTemplate {
  id: number = 0;
  disabled: boolean = false;
  templateName: string = null;
  templateDescription: string = null;
  deviceID: number = 0;
  tourNr: string;
  tourInfo: string;
  sortOrder: number;
  companyID: number;
  shiftID: number;
  recurrencyPattern: RecurrencyPattern;
  loadingTemplates: LoadingTemplate[] = [];
  orderTemplates: OrderTemplate[] = [];

  static fromTour(tour) {
    let tourTemplate = new TourTemplate();
    Object.assign(tourTemplate, {
      id: 0,
      disabled: false,
      templateName: null,
      templateDescription: null,
      deviceID: Math.abs(tour.deviceID),
      tourNr: tour.tourNr,
      tourInfo: tour.tourInfo,
      sortOrder: tour.sortOrder,
      companyID: tour.companyID,
      shiftID: tour.shiftID,
      recurrencyPattern: new RecurrencyPattern(),
      loadingTemplates: Array.isArray(tour.loadings) ? tour.loadings.map(l => LoadingTemplate.fromLoading(l)) : [],
      orderTemplates: Array.isArray(tour.orders) ? tour.orders.map(o => OrderTemplate.fromOrder(o)) : []
    });
    return tourTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tour-template.ts